import {createImmutableMapFromArray} from '../../common/collection/collectionUtils';

const MULTI_BANNER_TYPE_DELIMITER = '-';

function generateBannerTypesParamString(bannerTypes) {
  return bannerTypes.join(MULTI_BANNER_TYPE_DELIMITER);
}

function generateBannersMap(responseData) {
  if(!responseData) {
    return null
  }
  return createImmutableMapFromArray(
    responseData,
    {
      propertyName: 'type',
      transformer: (resultMap, element, config) => {
        resultMap.set(element[config.propertyName], element.banners);

        return resultMap;
      },
    }
  );
}

export {
  generateBannerTypesParamString,
  generateBannersMap,
}
